// hook - форма подключена через хук useFormConnector,
// иной коммент - причина, по которой форма не подключена через хук
//

export const FormNames = {
	POPUPGROUP: {
		POPUP_EDIT_FORM: 'popupEditForm', // closeOnSubmitForm
	},
	BLOCKGROUPPRODUCT: {
		BLOCK_GROUP_PRODUCT_EDIT_FORM: 'blockGroupProductEditForm', // closeOnSubmitForm
	},
	ADMIN: {
		PRODUCT_ORDER_STATUS_EDIT_FORM: 'productOrderStatusEditForm', // closeOnSubmitForm
		MONITORING_FORM: 'monitoringForm', // unnecessary
		LANDING: 'landing',
		TEMPLATE: 'template',
		TAGS_FORM: 'tag_form',
	},
	PP: {
		MATRIX_ROLE: 'matrix-role', // unnecessary
		MASS_USE_MERCHANT: 'mass-use-merchant',
		MASS_UPDATE_CURATOR: 'mass_update_curator',
		CONTRACT_REGISTRY_EDIT: 'contract_registry_edit',
		AFFILIATE_PROGRAM_REPORT: 'affiliate_program_reports',
	},
	CREATE_LEAD_FORM: 'create_lead_form', // class component
	FIND_LEAD_FORM: 'find_lead_form', // class component
	EDIT_RBIDOS_REQUEST_FORM: 'edit_rbidos_request_form', // class component
	EDIT_ADDRESS_RBIDOS_REQUEST_FORM: 'edit_address_rbidos_request_form', // class component
	EDIT_ADDRESS_FIAS_RBIDOS_REQUEST_FORM: 'edit_address_fias_rbidos_request_form', // class component
	OCHKA_LOGIN_FORM: 'ochka_login_form', // class component
	ORDERS: {
		BUILD_ORDER: 'orders/build_order', // hook
		EDIT_ORDER: 'orders/edit_order', // hook
		NEW_CONSENT: 'orders/new_consent',
		RESEND_CODE_CONSENT: 'orders/resend_code_consent',
		ERROR_CONSENT: 'orders/error_consent',
		CANCEL_STATUSES: 'orders/cancel_statuses',
		UPLOAD_STATUSES: 'orders/upload_statuses',
		ORDERS_FILTER: 'orders/filters',
		EXTERNAL_FORMS: 'external_forms',
		EXTERNAL_ORDER_FORM: 'external_order_form',
		REGION_FORM: 'region_form',
		UNBLOCK_FIND_FORM: 'unblock_find_form',
		ORDERS_FIND__FORM: 'orders_find__form',
		PRODUCT_SETTING_FORM: 'product_setting_form',
		EDIT_PRODUCT_FORM: 'edit_product_form',
		EXTERNAL_FORMS_MARK: 'external_forms_mark',
		BLOCKING_RULES_FORM: 'blocking_rules_form',
		MERCHANTBRANCH_FORM: 'merchantBranch_form',

		MOBILE: {
			FILTER: 'orders/filters_mobile',
			CHECK_INN: 'orders/inn',
			AGREEMENT: 'orders/agreement',
			PRODUCTS: 'orders/products',
			PRODUCTS_CART: 'orders/cart',
			ORDER_FORM: 'orders/form',
			RESERVE: 'reserve/form',
		},
	},
	LANDING: {
		RKO: 'rko', // unnecessary
	},
	LOGIN_FORM: 'login_form', // hook
	PROFILE: {
		MAIN: 'profile-main-form',
		CHANGE_PASSWORD: 'change_password', // hook
		CHANGE_USERNAME: 'change_username',
		DATA_USER: 'data_user', // class component
		TWO_FACTOR_AUTH: 'two_factor_auth',
	},
	RESTART_ORDER: 'restart_order', // closeOnSubmitForm
	REFERENCE_BOOK: {
		TERRITORIAL_BANK: 'reference_book/territorial_bank', // closeOnSubmitForm
		GOSB: 'reference_book/gosb', // closeOnSubmitForm
		SECTOR: 'reference_book/sector', // closeOnSubmitForm
		CHANNEL_FILTER: 'reference_book/channel_filter', // unnecessary
		SPECIAL_OFFER: 'special_offer', // hook
		CHANNEL: 'channel',
		CITIES: 'cities',
	},
	BROKER: {
		CREATE_BG: 'ibro/create_bg',
		BUILD_BG: 'ibro/create_bg',
		REQUEST: {
			ABOUT: 'ibro/request_about',
			GUARANTEE_BLANK: 'ibro/guarantee_blank',
			DOCUMENTS: 'ibro/documents',
			COST: 'ibro/cost',
			CLIENT_INFO: 'ibro/client_info',
			TAX_REPORT: 'ibro/tax_report',
			GUARANTEE_PROJECT: 'ibro/guarantee_project',
		},
		AGREEMENT: 'ibro/agreement',
		CALCULATE: 'ibro/calculate',
		CUSTOMER_LIMIT_MODAL_FORM: 'ibro/customer_limit_modal_form',
		FILTERS: 'ibro/filters',
		CREATE_LIMIT: 'ibro/create_limit',
		LIMIT: 'ibro/limit',
		ASSIGN: 'ibro/assign',
		NOTIFICATION_SETTING: 'ibro/notification_setting',
		CODE_EMAIL: 'code_email_confirm',
		GUARANTEE_SEND: 'ibro/guarantee_send',
		PUBLICATION: 'ibro/publication',
	},
	BROKER_SETTINGS: {
		TRUST: 'ibro_settings/trust',
	},
	ARCHIVE_BROKER: {
		FILTERS: 'archive_broker/filters',
	},
	PARTNER_PAYMENT: 'partner_payment', // hook
	COMMON: {
		FIND_FORM: 'find-form-with-filters',
		CODE_EMAIL: 'code_email_confirm',
		NEWS_EDIT_FORM: 'news_edit_form',
	},
	SETTINGS: {
		BG_BLACK_LIST: 'bg_black_list',
		ORDERS_BLACK_LIST: 'orders_black_list',
	},
	COLISEUM: {
		PARTNER_SETTING: 'partner_setting',
		SETTINGS: 'settings',
		CALL_FORM: 'call_form',
		CALL_FIND_FORM: 'call_find_form',
		CALL_FIND__FORM: 'call_find__form',
		BLOCK_FIND__FORM: 'block_find__form',
		BLACKLIST_FIND__FORM: 'blacklist_find__form',
		BLACKLIST_FORM: 'blacklist_form',
		BLACKLIST_FIND_FORM: 'blacklist_find_form',
	},
	FIND_INN: 'find_inn',
	AUTH: {
		RESET_PASSWORD_BY_TOKEN: 'auth/reset_password_by_token',
		RESET_PASSWORD_FORM: 'auth/reset_password_form',
		REFRESH_PASSWORD_MODAL: 'auth/refresh_password_modal',
	},
	SURVEY: {
		OPTIONS_VIEW: 'survey/options_view',
		SURVEY_EDIT: 'survey_edit',
		SURVEY_QUESTION_EDIT: 'survey_question_edit',
		SURVEY_RESULTS_FILTERS: 'survey_results_filters',
	},
	KNOWLEDGE: {
		VIDEO_EDIT: 'knowledge/video_edit',
		CHOOSE_USER: 'knowledge/choose_user',
		PROJECT_CREATE: 'knowledge/project_create',
	},
	FAKE_RESPONSES: {
		DADATA_SUGGEST_BY_ID_PARTY: 'fake_responses/dadata_suggest_by_id_party',
	},
	DRS_FAKE_RESPONSES: {
		DRS_DADATA_SUGGEST: 'fake_responses/reserve_accounts',
	},
	RBIDOS_LOAD_COMPANY: {
		SUGGEST_KR_DRS: 'fake_responses/rbidos_load_company',
	},
	MODAL: {
		FEEDBACK: 'modal/feedback',
		CLIENT_DOCUMENTS: 'modal/client_documents',
	},
	AGREEMENT: {
		EDIT: 'agreement/edit',
		FILTERS_FORM: 'agreement/filtersForm',
	},
	RBIDOS_ACCESS: {
		FORM: 'rbidos_access_form',
		EDIT: 'rbidos_access_edit',
		SIGN: 'rbidos_access_sign_documents',
		AGENT: 'rbidos_access_agent',
		LOGIN_IIT: 'login_iit',
	},
	DEPARTMENT: {
		FILTER: 'department/filter',
		EDIT: 'department/edit',
		SIGN: 'rbidos_access_sign_documents',
	},
	PARTNER_REQUEST: {
		FILTER: 'partnerRequest/filter',
		EDIT: 'partnerRequest/edit',
		CREATE: 'partnerRequest/create',
		CHANGE_STATUS: 'partnerRequest/changeStatus',
		CHANGE_AGREEMENT_STATUS: 'partnerRequest/changeAgreementStatus',
		DOCUMENTS_INFOTECS: 'partnerRequest/documentInfotecs',
	},
	PARTNER: {
		ADD_DOCUMENT: 'add_document',
		FILTER_ONE_DAY: 'filter_one_day',
		DISTRIBUTION_ONE_DAY: 'distribution_one_day',
	},
	MERCHANT_STATUS: {
		FILTER: 'merchant_status/filter',
		EDIT: 'merchant_status/edit',
	},
	BUSINESSAPPS: {
		EDIT: 'businessapps/edit',
	},
	REGISTRATOR_CABINET: {
		FILTERS_FORM: 'registratorCabinet',
		ORDER_CREATE: 'orderCreate',
		ORDER_PAID_CREATE: 'orderPaidCreate',
		ORDER_EDIT: 'registratorOrderEdit', // hook
		EMAIL_OR_PHONE_CONFIRMATION: 'registratorEmailOrPhoneConfirmation', // hook
		FIND_OUT_INN: 'registratorFindOutInn',
		USTAV: 'ustav',
		ORDER_COPY: 'orderCopy',
		PATENT: 'patent',
		MOBILE: {
			FILTER: 'registratorCabinet/filters',
		},
	},
	ADVERTISMENT: {
		ORG_FILTER: 'advertisment/filter_org',
		CONTR_FILTER: 'advertisment/filter_contr',
		CREATIVE_FILTER: 'advertisment/filter_creative',
		INVOICE_FILTER: 'advertisment/filter_invoice',
		CREATE_ORG: 'advertisment/create_org',
		CREATE_PLATFORMS: 'advertisment/create_platforms',
		CREATE_CONTRACT: 'advertisment/create_contract',
		CREATE_CREATIVE: 'advertisment/create_creative',
		CREATE_MEDIA: 'advertisment/create_media',
		CREATE_REPORT: 'advertisment/create_report',
		CREATE_PUBLICATION: 'advertisment/create_publication',
		REPORT_AUTOMATION: 'advertisment/report_automation',
		UNLOAD_REPORT: 'unload_report',
		ORD_REPORT: 'ord_report',
	},
	TASK_STATS: {
		FILTER: 'task_stats/filter',
	},
	PARTNER_PROFILE: {
		PRELOGIN: 'prelogin',
		INIVATE: 'inivate',
		REGISTRATION: 'registration',
		BLACK_LIST_PARTNER: 'black_list_partner',
	},
	MODULE: {
		RATING: 'rating',
	},
	COMPANY_ADDRESS: {
		FIND: 'find',
		FILTER: 'filter',
		ADDRESS: 'address',
	},
	INTERFACE_ELEMENT: 'interface_element_form',
	BANK_EMPLOYEES: {
		FILTER: 'bankEmployees/filter',
		MAIN: 'bankEmployees/main',
	},
	USERS: {
		EMAIL_CONSENT: 'email_consent',
	},
	ACTS: {
		FILTER: 'filter',
	},
	MASS_ASSIGN_PRODUCTS: 'mass_assign_products',
	SOM: {
		LIMIT_FORM: 'sms_limit_form',
		RULE_FORM: 'sms_rule_form',
	},
}
